// Shared label/color map for order_log.event_type, used by both the header
// "Order Logs" dropdown and the full /order-log list page so they never
// drift out of sync. Mirrors the event types written in
// bankend/app/helpers/paper-trading-notify.js.
export const ORDER_LOG_TYPES = {
  signal_selected: { label: 'Signal Selected', color: 'info' },
  order_placed: { label: 'Order Placed', color: 'primary' },
  trade_closed: { label: 'Trade Closed', color: 'success' },
  order_failed: { label: 'Order Failed', color: 'error' },
  resting_stop_failed: { label: 'Stop Placement Failed', color: 'error' },
  slippage_alert: { label: 'Slippage Alert', color: 'warning' },
  quote_sanity_failed: { label: 'Quote Integrity Failed', color: 'warning' },
};

export function orderLogTypeLabel(eventType) {
  return ORDER_LOG_TYPES[eventType]?.label || eventType;
}

export function orderLogTypeColor(eventType) {
  return ORDER_LOG_TYPES[eventType]?.color || 'secondary';
}
